import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import { DetailedUserInfo } from './forms/DetailedUserInfo'
import { ChildFormHandle } from '@/routes/admin/users/user/forms/types'
import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { useMutation } from '@tanstack/react-query'
import UserStyles from '@/routes/admin/users/user/User.module.scss'
import { HashLoader } from 'react-spinners'
import { Button } from 'devextreme-react'
import { useParams, useRevalidator } from 'react-router-dom'
import { Editableinfo_impiegato, giorno_lavorativo } from '@/model/qsadminapi/QsAdminApiModuleModel'
import { FIXED_WORKING_HOURS_MODE } from '@/routes/admin/users/user/User.types'

export type UserInfoPaneProps = {
  infoId?: number
}

export const UserInfoPane = forwardRef<ChildFormHandle, UserInfoPaneProps>((props, ref) => {
  const qsadminapiService = useQsAdminApiManager()
  const { userId } = useParams()
  const detailedUserInfoRef = useRef<ChildFormHandle>(null)
  const revalidator = useRevalidator()

  // Forward the submit method to the detailedUserInfoRef
  useImperativeHandle(ref, () => ({
    validate: () => {
      return detailedUserInfoRef.current?.validate() ?? true
    },
    submit: () => {
      detailedUserInfoRef.current?.submit()
    },
  }))

  // Mutation for creating new user info
  const createUserInfoMutation = useMutation({
    mutationFn: async () => {
      const newInfo = await qsadminapiService.service.info_impiegato().create({
        modalita_orario_lavorativo: FIXED_WORKING_HOURS_MODE,
        ore_settimanali: 0,
      } as Editableinfo_impiegato)
      for (let index = 0; index <= 7; index++) {
        const giorno_lavorativo: giorno_lavorativo = {
          id: 0,
          giorno: index,
          attivo: index >= 1 && index <= 5,
          entrata_mattina: new Date(1970, 0, 1, 8, 30, 0).toISOString(),
          uscita_mattina: new Date(1970, 0, 1, 13, 0, 0).toISOString(),
          orario_continuato: false,
          entrata_pomeriggio: new Date(1970, 0, 1, 14, 0, 0).toISOString(),
          uscita_pomeriggio: new Date(1970, 0, 1, 17, 30, 0).toISOString(),
          ore: 8,
          info_impiegato: newInfo.data,
        }
        await qsadminapiService.service.giorno_lavorativo().create(giorno_lavorativo)
      }
      await qsadminapiService.service.user(Number(userId)).patch({
        // @ts-expect-error the api only acceps an editable user, but this is wrong, it should accept a full user, inlcuding collections as this works
        info: newInfo.data,
      })
    },
    onSuccess: async (data) => {
      revalidator.revalidate()
    },
    onError: async (error) => {
      // api is wrongly returning 500 status code
      // fix this ASAP
      revalidator.revalidate()
    },
  })
  // const deleteUserInfoMutation = useMutation({
  //   mutationFn: async () => {
  //     await qsadminapiService.service.user(Number(userId)).patch({
  //       info: null,
  //     })
  //     await qsadminapiService.service.info_impiegato(Number(props.infoId)).delete()
  //   },
  //   onSuccess: async (data) => {
  //     revalidator.revalidate()
  //   },
  // })

  return props.infoId ? (
    <>
      <DetailedUserInfo infoId={props.infoId} ref={detailedUserInfoRef} />
      {/*<Button*/}
      {/*  text="Elimina Informazioni Utente"*/}
      {/*  type="danger"*/}
      {/*  onClick={() => deleteUserInfoMutation.mutate()}*/}
      {/*  disabled={deleteUserInfoMutation.isPending}*/}
      {/*/>*/}
    </>
  ) : (
    <div className="content-block">
      <h2>Informazioni dettagliate utente</h2>
      <p>Non sono state trovate informazioni dettagliate. Vuoi aggiungerle?</p>
      <Button
        text="Crea Informazioni Utente"
        type="default"
        onClick={() => createUserInfoMutation.mutate()}
        disabled={createUserInfoMutation.isPending}
      />
      {createUserInfoMutation.isPending && (
        <div className={UserStyles.loaderWrapper}>
          <HashLoader loading={true} size={50} color={'#ff5722'} />
        </div>
      )}
    </div>
  )
})

UserInfoPane.displayName = 'UserInfoPane'
